import { TextQuestion } from "@cur8/questionnaire";
import { Trans } from "./trans";

export const HealthProblems = new TextQuestion(
  <Trans.HealthProblems.Question />
);
